import type { UpdateClienteIntermedioPayload } from "@/interfaces/user.interface";
import { axiosInstance } from "@retro-ia/shared/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export const useUpdateClienteIntermedioWithUsuario = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: UpdateClienteIntermedioPayload) => {
      const res = await axiosInstance.patch(
        `/clientes-intermedios/${id}`,
        data,
        {
          withCredentials: true,
        }
      );
      return res.data;
    },
    onSuccess: () => {
      toast.success("Cliente actualizado correctamente.");
      queryClient.invalidateQueries({ queryKey: ["clientesIntermedios"] });
    },
    onError: () => {
      toast.error("Error al actualizar");
    },
  });
};
